export const results = {
  SUCCESS: 'הצלחה',
  FAIL: 'כשלון'
}